import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
    .react-select__menu {
        min-width: 350px;
    }

    @media (max-width: 400px) {
        .react-select__menu {
            min-width: 310px;
        }
    }
`

export const DroppableContainer = styled.div`
  && {
    display: flex;
    flex-direction: column;
    gap: 8px;

    > :last-child {
      margin-bottom: 20px;
    }
  }
`
